import {
  formatToReal,
  getColorScore,
  getImageURLScore,
} from "../../../utils/utils";
import TitleStripe from "../TitleStripe";

const riskData = [
  {
    range: [0, 400],
    risk: "Alto",
    message:
      "Risco de Crédito Alto: Capacidade de pagamento menor do que a média da população brasileira. Probabilidade de pagamento: 1%. A chance deste consumidor não pagar nos próximos meses é de 99%",
  },
  {
    range: [401, 500],
    risk: "Alto",
    message:
      "Risco de Crédito Médio: Capacidade de pagamento menor do que a média da população brasileira. Probabilidade de pagamento: 7%. A chance deste consumidor não pagar nos próximos meses é de 93%",
  },
  {
    range: [501, 600],
    risk: "Alto",
    message:
      "Risco de Crédito Alto: Capacidade de pagamento menor do que a média da população brasileira. Probabilidade de pagamento: 29%. A chance deste consumidor não pagar nos próximos meses é de 71%",
  },
  {
    range: [601, 700],
    risk: "Médio",
    message:
      "Risco de Crédito Médio: Capacidade de pagamento menor do que a média da população brasileira. Probabilidade de pagamento: 63%. A chance deste consumidor não pagar nos próximos meses é de 37%",
  },
  {
    range: [701, 800],
    risk: "Médio",
    message:
      "Risco de Crédito Médio: Capacidade de pagamento menor do que a média da população brasileira. Probabilidade de pagamento: 82%. A chance deste consumidor não pagar nos próximos meses é de 18%",
  },
  {
    range: [801, 900],
    risk: "Baixo",
    message:
      "Risco de Crédito Baixo: Capacidade de pagamento maior do que a média da população brasileira. Probabilidade de pagamento: 93%. A chance deste consumidor não pagar nos próximos meses é de 7%",
  },
  {
    range: [901, 1000],
    risk: "Baixo",
    message:
      "Risco de Crédito Baixo: Capacidade de pagamento maior do que a média da população brasileira. Probabilidade de pagamento: 98%. A chance deste consumidor não pagar nos próximos meses é de 2%",
  },
];

const ScorePF = ({ data }) => {
  const riskInfo = riskData.find(
    ({ range }) =>
      +data?.QuodScore?.Score >= range[0] && +data?.QuodScore?.Score <= range[1]
  );

  return (
    <>
      <TitleStripe>Score 5.0</TitleStripe>
      <div className="grid grid-cols-2 gap-10">
        <div className="pt-2 px-14 pb-0 max-w-md mx-auto">
          <img src={getImageURLScore(data?.QuodScore?.Score)} />
          <div
            className="font-semibold text-lg rounded p-2 w-fit text-white shadow-md mx-auto"
            style={{
              background: `${getColorScore(data?.QuodScore?.Score)}`,
            }}
          >
            Score {data?.QuodScore?.Score}
          </div>
        </div>

        <div className="mt-10">
          <div>
            {riskInfo ? (
              <div>
                <h3 className="font-semibold text-lg uppercase">Risco: {riskInfo.risk}</h3>
                <p className="border border-gray-200 p-2 mt-2 bg-gray-100">{riskInfo.message}</p>
              </div>
            ) : (
              <p>Score inválido</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ScorePF;
